import * as React from "react";
import { cn } from "../../lib/cn";

type ButtonVariant = "primary" | "secondary" | "danger" | "ghost";
type ButtonSize = "sm" | "md";

export type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: ButtonVariant;
  size?: ButtonSize;
};

export function buttonClassName({
  variant = "primary",
  size = "md",
  className,
}: {
  variant?: ButtonVariant;
  size?: ButtonSize;
  className?: string;
}) {
  return cn(
    "inline-flex items-center justify-center gap-2 rounded-xl border font-semibold",
    "transition-[background-color,box-shadow,transform] active:translate-y-px focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#8d9f66]/60",
    "disabled:opacity-60 disabled:pointer-events-none",
    size === "sm" ? "h-9 px-3 text-sm" : "h-10 px-4 text-sm",
    variant === "primary" &&
      "bg-[#353e2e] hover:bg-[#48563b] border-[#252922] text-white shadow-[2px_2px_0_#b4c187]",
    variant === "secondary" &&
      "bg-[#fffefa] hover:bg-[#eef0e6] border-[#cfd3c5] text-[#353e2e] shadow-[0_2px_0_#e5e5dc]",
    variant === "danger" &&
      "bg-red-700 hover:bg-red-800 border-red-800 text-white shadow-sm",
    variant === "ghost" && "border-transparent hover:bg-gray-100 text-gray-900",
    className,
  );
}

export function Button({
  className,
  variant = "primary",
  size = "md",
  ...props
}: ButtonProps) {
  return (
    <button
      className={buttonClassName({ variant, size, className })}
      {...props}
    />
  );
}
